import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'

function LicenseInfo({name, version, author, license, licenseText}) {
  return (
    <div className="license">
      <div className="license__first-row">
        <span className="license__name">{name}</span>
        <span className="license__version">{`@${version}`}</span>
        {author && <span className="license__author">{`(${author})`}</span>}
      </div>
      <div className="license__license">{`${i18n.t('license')}: ${license}`}</div>
      <div className="license__text">{licenseText}</div>
    </div>
  )
}

LicenseInfo.propTypes = {
  name: PropTypes.string,
  version: PropTypes.string,
  author: PropTypes.string,
  license: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  licenseText: PropTypes.string,
}

function LicenseComponent({licensesJson}) {
  return (
    <div className="licenses">
      {licensesJson.map(info => (
        <LicenseInfo key={info.name + info.version} {...info} />
      ))}
    </div>
  )
}

LicenseComponent.propTypes = {
  licensesJson: PropTypes.array,
}

export default LicenseComponent
